import { Outlet } from 'react-router'
import { IgnoreRentner } from '../ignore-rentner'

export function Root() {
	return (
		<>
			<div className="mb-6 flex gap-4 justify-between items-center">
				<h2 className="text-lg">Dashboard</h2>
				<IgnoreRentner />
			</div>
			<div className="grow">
				<Outlet />
			</div>
		</>
	)
}
